/*
 * @Author: wangbaihe
 * @Date: 2023-04-28 10:36:47
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-09-10 09:49:43
 * @FilePath: \common-mediax\src\apis\MediaCloudArticleMy\myHandle.js
 * @Description:
 */
import { createAPI } from '@common'
// MediaCloudArticleMyHandle
export default {
  // 读检索条件
  getConditions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0dpoejujpot', 'get', config),
  getActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0bdujpot', 'POST', config),

  // 部门库获取作者和当前用户
  postUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0obnft', 'POST', config),

  getPlanOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0ofxtqmbo0pqujpot', 'get', config),
  // 报纸栏目库签发日期查询条件项
  getDateOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0rvfsz0ebuft0pqujpot', 'get', config),
  // 报纸栏目库查询条件最后处理人条件项
  getUserOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0rvfsz0vtfst0pqujpot', 'get', config),
  // 报纸栏目库查询稿件状态条件项
  getPaperStatusOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bsujdmft0rvfsz0tubuvt0pqujpot', 'get', config),
  // 获取状态列表（期刊发布库在使用
  getMyStatusOptions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0iboemfnz0rvfsz0tubuvt0pqujpot', 'get', config)
}
